<template>
  <div>
    <div v-if="baustelle.length">
      <h2>Bauvorhaben {{ baustelle[0].adresse }}, {{ baustelle[0].bauherr }}</h2>
      <table class="toptable">
        <tbody>
          <tr>
            <th scope="row">Bauherr</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].bauherr" />
            </td>
          </tr>
          <tr>
            <th scope="row">Bauvorhaben</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].bvh" />
            </td>
          </tr>
          <tr>
            <th scope="row">Baustellenadresse</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].adresse" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftraggeber</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].auftraggeber" />
            </td>
          </tr>

          <tr>
            <th scope="row">Rechnungsempfänger</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].empfaenger" />
            </td>
          </tr>
          <tr>
            <th scope="row">Rechnungsadresse</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].rechnungsadresse" />
            </td>
          </tr>
          <tr>
            <th scope="row">PLZ, Ort</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].plz" />
            </td>
          </tr>

          <tr>
            <th scope="row">UID Nummer</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].uid" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftragssumme</th>
            <td>
              <input type="number" v-model.number="baustelle[0].auftragssumme" />
            </td>
          </tr>
          <tr>
            <th scope="row">Zahlungskonditionen</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].zkn" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftragsdatum</th>
            <td>
              <input type="date" v-model="baustelle[0].auftragsdatum" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftragsnummer</th>
            <td>
              <input type="text" v-model.trim="baustelle[0].auftragsnummer" />
            </td>
          </tr>
          <tr>
            <th scope="row">Leistungszeitraum</th>
            <td>
              Beginn:
              <input class="oneline" type="date" v-model="baustelle[0].beginn" />Ende:
              <input class="oneline" type="date" v-model="baustelle[0].ende" />
            </td>
          </tr>
          <tr>
            <th scope="row">Anmerkungen</th>
            <td>
              <textarea rows="4" cols="100" v-model="infos"></textarea>
            </td>
          </tr>
          <tr>
            <th scope="row">Erstellt am</th>
            <td>{{baustelle[0].createdOn | formatDate}}</td>
          </tr>
          <tr>
            <th scope="row">Erstellt von</th>
            <td>{{baustelle[0].userName}}</td>
          </tr>
        </tbody>
      </table>
      <h2>Zahlungsplan</h2>
      <table class="zp" v-if="baustelle[0].zahlungsplan">
        <tbody>
          <tr class="table-head">
            <th>TR</th>
            <th>Datum</th>
            <th>RG NR</th>
            <th>Leistungsstand</th>
            <th>Rechnungsbetrag</th>
            <th>+20% Mwst</th>
            <th>Verrechnet</th>
            <th>Bezahlt</th>
            <th>Summe</th>
          </tr>
          <tr v-for="zp in baustelle[0].zahlungsplan" v-bind:key="zp.id">
            <th scope="row">TR {{ zp.TR }}</th>
            <td>
              <input type="date" v-model.trim="zp.datum" />
            </td>
            <td>
              <input type="text" v-model.trim="zp.rgnr" />
            </td>
            <td>
              <input type="number" v-model.number="zp.leistungsstand" />
            </td>
            <td>
              <input type="number" v-model.number="zp.rechnungsbetrag" />
            </td>
            <td
              v-if="zp.rechnungsbetrag"
            >{{ (zp.rechnungsbetrag * 0.2 + zp.rechnungsbetrag).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
            <td v-else></td>
            <td>
              <input type="checkbox" v-model="zp.verrechnet" />
            </td>
            <td>
              <input type="checkbox" v-model="zp.bezahlt" />
            </td>
            <td>
              <input type="number" v-model.number="zp.summe" />
            </td>
          </tr>
          <tr v-if="baustelle[0].addons && baustelle[0].addons.count > 0" style="background: #e4e4e4;">
            <th scope="row"></th>
            <td></td>
            <td></td>
            <td style="font-weight: bold;">Zusätzliche Positionen</td>
            <td>{{ (baustelle[0].addons.count * baustelle[0].addons.price).toLocaleString('de-DE', {minimumFractionDigits: 2}) }}</td>
            <td>
              {{ ((baustelle[0].addons.count * baustelle[0].addons.price ) * 0.2 + (baustelle[0].addons.count * baustelle[0].addons.price )).toLocaleString('de-DE', {minimumFractionDigits: 2}) }}
            </td>
            <td style="font-weight: bold;">
              SR + ZP
            </td>
           <td>
            {{ (baustelle[0].zahlungsplan[baustelle[0].zahlungsplan.length - 1].rechnungsbetrag + (baustelle[0].addons.count * baustelle[0].addons.price)).toLocaleString('de-DE', {minimumFractionDigits: 2}) }}
           </td>
            <td>
              {{ ((baustelle[0].zahlungsplan[baustelle[0].zahlungsplan.length - 1].rechnungsbetrag + (baustelle[0].addons.count * baustelle[0].addons.price)) * 1.2 ).toLocaleString('de-DE', {minimumFractionDigits: 2}) }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row-buttons">
        <button @click="addRow" class="row-button">+</button>
        <div v-if="baustelle[0].zahlungsplan.length > 1">
          <button @click="removeRow" class="row-button">-</button>
        </div>
      </div>

      <div class="add">
        <h2>Zusätzliche Rechnungspositionen</h2>
        <table>
          <tr>
            <td>Anzahl</td>
            <td>
              <input v-model="baustelle[0].addons.count" type="number" placeholder="3">
              <span class="clear" @click="baustelle[0].addons.count = 0">x</span>
            </td>
          </tr>
          <tr>
            <td>Position</td>
            <td>
              <input v-model="baustelle[0].addons.name" type="text" placeholder="Zusätzliche Baustellenbesuche">
              <span class="clear" @click="baustelle[0].addons.name = null">x</span>
            </td>
          </tr>
          <tr>
            <td>Nettopreis</td>
            <td>
              <input v-model="baustelle[0].addons.price" type="number" placeholder="80">
              <span class="clear" @click="baustelle[0].addons.price = 0">x</span>
            </td>
          </tr>
        </table>
      </div>

      <div>
        <h2>To Do</h2>
        <table>
            <tr>
            <td>Vorankündigung</td>
            <td><input type="checkbox" v-model="baustelle[0].vorankuendigung"></td>
          </tr>
          <tr>
            <td>Unterlage für spätere Arbeiten</td>
            <td><input type="checkbox" v-model="baustelle[0].ufa"></td>
          </tr>
          <tr>
            <td>Pläne</td>
            <td><input type="checkbox" v-model="baustelle[0].plaene"></td>
          </tr>
          <tr>
            <td>Firmen</td>
            <td><input type="checkbox" v-model="baustelle[0].firmen"></td>
          </tr>
          <tr>
            <td>BZP</td>
            <td><input type="checkbox" v-model="baustelle[0].bzp"></td>
          </tr>
          <tr>
            <td>SiGe</td>
            <td><input type="checkbox" v-model="baustelle[0].sige"></td>
          </tr>
        </table>
      </div>

      <div class="buttons">
        <button class="button btn-edit" @click="update">Speichern</button>
        <button class="button btn-edit" @click="exit">Abbrechen</button>
        <button class="button btn-edit warn" @click="deleteBst">Löschen</button>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../fbConfig");
import moment from "moment";
import router from "../router/index";

export default {
  name: "Edit",
  props: ["baustelle", "id"],
  data() {
    return {
      infos: "Blank"
    }
  },
  methods: {
    exit() {
      this.$emit("exit");
    },
    update() {
      this.baustelle[0].info = this.infos;
      this.$emit("update")
    },
    addRow() {
      let nextRow = this.baustelle[0].zahlungsplan.length + 1;
      this.baustelle[0].zahlungsplan.push({
        TR: nextRow,
        id: nextRow,
        datum: "",
        rgnr: "",
        leistungsstand: "",
        rechnungsbetrag: 0,
        bezahlt: false,
        summe: 0
      });
    },
    removeRow() {
      this.baustelle[0].zahlungsplan.pop();
    },
    deleteBst() {
      fb.baustellen
        .doc(this.id)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          router.push({ name: "Baustellen" });
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD.MM.YYYY");
    }
  },
  created() {
    this.infos = this.baustelle[0].info ? this.baustelle[0].info : "";
    this.baustelle[0].addons = this.baustelle[0].addons ? this.baustelle[0].addons : {count: 0, name: null, price: 0}
  }
};
</script>

<style scoped>
table {
  width: 65%;
  text-align: left;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

.zp {
  width: 100%;
}

td,
th {
  border: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

.btn-edit {
  margin-top: 5px;
  margin-right: 5px;
  margin-left: 2px;
}

.row-buttons {
  display: flex;
}

.row-button {
  border: none;
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 2px;
  border: 1px solid #999;
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.row-button:hover {
  border: 1px solid #2c3e50;
  color: #fff;
  background: #2c3e50;
}

.warn {
  background-color: rgb(209, 49, 0);
  border: 1px solid rgb(209, 49, 0);
}

.warn:hover {
  border: 1px solid rgb(209, 49, 0);
  background-color: transparent;
  color: rgb(209, 49, 0);
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  border: none;
  outline: none;
  background: transparent;
  font-family: "Avenir";
}

textarea {
  background: transparent;
}

.toptable td:last-of-type {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.zeitraum {
  padding-left: 10px;
  height: 40px;
}

.oneline {
  width: 150px;
  height: 26px;
  padding: 0;
}

.buttons {
  margin-top: 10px;
}

.add input {
  width: 93%;
  box-sizing: border-box;
  padding: 5px;
  border: none;
  outline: none;
  /* background: rgba(255, 255, 255, 0.721); */
  background: transparent;
  font-family: "Avenir";
}

::placeholder {
  color: rgb(148, 148, 148);
}

.clear {
  cursor: pointer;
}
</style>